import React from 'react'
import "./BasePage.css"

export default props => (
    <div className="BasePage">
        {props.children}
    </div>
)